import React, { useState, useContext, useEffect } from 'react';
import Card, { CardBody, CardFooter } from '../../components/bootstrap/Card';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import logo from '../../assets/images/brand_dark.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../components/bootstrap/Button';
import classNames from 'classnames';
import useDarkMode from '../../hooks/useDarkMode';
import LANG, { getLangWithKey } from '../../lang';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/icon/Icon';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import { useFormik } from 'formik';
import InputGroup from '../../components/bootstrap/forms/InputGroup';
import showNotification from '../../components/extras/showNotification';
import UserService from '../../services/UserService';
import { useMst } from '../../models';
import ThemeContext from '../../contexts/themeContext';
import moment from 'moment';
import cardImage from "../../assets/images/test_card.svg";
import ReactDragList from "react-drag-list";
import ReportService from '../../services/ReportService'

const Question = (props) => {
	const navigate = useNavigate();

	const { user, config } = useMst();
	const [step, setStep] = useState(0);
	const [answerTemp, setAnswerTemp] = useState([]);

	useEffect(() => {
		if (!user.id) {
			config.setPrevPage('/question')
			navigate('/login')
			return
		}
		
	    setStep(0);

	    const getQuestions = async () => {
	        const history = await ReportService.getHistory();

	        let reportCount = history.data.length;
	        const questionResult = await ReportService.getQuestions();

	        console.log(questionResult);
	        if (questionResult.result && questionResult.code === 200) {
	            // step.setQuestions(questionResult.data);

	            let basic = [];
	            let recovery = [];
	            let temp = [];

	            for (let i = 0; i < questionResult.data.length; i++) {
	                if (questionResult.data[i].type === "basic") {
	                    basic.push({
	                        type: questionResult.data[i].type,
	                        title: questionResult.data[i].question,
	                        answerType: questionResult.data[i].answerType,
	                        userId: user.id,
	                        questionsId: i < 9 ? questionResult.data[i].id : 0,
	                        answer: questionResult.data[i].options,
	                        options:
	                            questionResult.data[i].answerType === "rank"
	                                ? questionResult.data[i].options
	                                : [questionResult.data[i].options[0]],
	                    });
	                } else if (questionResult.data[i].type === "recovery") {
	                    recovery.push({
	                        type: questionResult.data[i].type,
	                        title: questionResult.data[i].question,
	                        answerType: questionResult.data[i].answerType,
	                        userId: user.id,
	                        questionsId: i < 9 ? questionResult.data[i].id : 0,
	                        answer: questionResult.data[i].options,
	                        options:
	                            questionResult.data[i].answerType === "rank"
	                                ? questionResult.data[i].options
	                                : [questionResult.data[i].options[0]],
	                    });
	                }
	            }
	            if (reportCount === 0) {
	                for (let i = 1; i <= 9; i++) {
	                    if (i === 9) {
	                        temp.push(basic[0]);
	                    } else {
	                        temp.push(basic[i]);
	                    }
	                    temp.push(recovery.splice(Math.floor(Math.random() * recovery.length), 1)[0]);
	                }
	            } else {
	                for (let i = 1; i <= 9; i++) {
	                    if (i === 9) {
	                        temp.push(basic[0]);
	                    } else {
	                        let rand = Math.random() * basic.length;
	                        if (rand === 0) rand = 1;
	                        temp.push(basic.splice(Math.floor(rand), 1)[0]);
	                    }
	                    temp.push(recovery.splice(Math.floor(Math.random() * recovery.length), 1)[0]);
	                }
	            }

	            setAnswerTemp(temp);
	            // console.log(answerTemp);
	            // console.log(temp);
	            // step.setAnswerInit(answerTemp);
	        } else {
	            // toast.error("질문지 불러오기 실패!! 처움부터 다시 시도!")
	            return;
	        }
	    };

	    getQuestions();
	}, [user.id, navigate, config]);

	const onUpdated = (e, updated) => {
		console.log(e, updated);
		if (e.oldIndex > e.newIndex) {
			for (let i = e.newIndex; i <= e.oldIndex; i++) {
				e.to.children[i].children[0].children[0].children[0].children[2].innerHTML = i + 1 + ". ";
			}
		} else {
			for (let i = e.oldIndex; i <= e.newIndex; i++) {
				e.to.children[i].children[0].children[0].children[0].children[2].innerHTML = i + 1 + ". ";
			}
		}

		// const a = {
		//   type: question.type,
		//   answerType: question.answerType,
		//   title: question.title,
		//   userId: user.id,
		//   questionsId: question.id,
		//   answer: JSON.parse(JSON.stringify(updated)),
		//   options: JSON.parse(JSON.stringify(question.options.toJSON())),
		// }

		// step.setAnswer(question.order-1, a)
	};


	return (
		<PageWrapper className="black-body" title={'Test'}>
			<div className='test-bg'></div>
			<Page>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-8 col-sm-8 text-center p-4'>
						<Card style={{
							elevation: 5,
							minHeight: "30vh",
							width: "100%",
							background: "#FFFFFF",
							boxShadow: "0px 0px 50px rgba(1, 1, 1, 0.44)",
							borderRadius: "10px",
							zIndex: 9999,
							// padding: "30px 40px 40px 40px",
						}}>
							{answerTemp.length > 0 && (
								<CardBody className='text-center'>
									<div style={{ borderRadius: 10, width: '100%', height: 10,  backgroundColor: '#EFEFEF'}}>
										<div style={{ borderRadius: 10, backgroundColor: '#00FF94', height: 10, width: (((step + 1) / 18) * 100) + '%' }}></div>
									</div>
									<div className='py-4'>
										<h3>{answerTemp[step].title}</h3>
									</div>
									<ReactDragList
										dataSource={answerTemp[step].options.sort(() => Math.random() - 0.5)} //렌더링할 데이터 레코드 배열
										rowKey="read" //렌더링할 행 키
										row={(record, index) => (
											<div key={"row-" + index}
												className='d-flex flex-row align-items-center justify-content-left mt-3'

												// style={{
												// 	boxSizing: "border-box",
												// 	display: "flex",
												// 	flexSirection: "row",
												// 	alignItems: "center",
												// 	padding: "15px",
												// 	gap: "5px",
												// 	background: "#FBFBFB",
												// 	border: "1px solid #E9E9E9",
												// 	borderRadius: "8px",
												// 	flex: "none",
												// 	order: 0,
												// 	flexGrow: 0,
												// }}
											>
												<Card className={`custom-box-shadow rounded-2 w-100 m-0`}
													style={{
													// 	boxSizing: "border-box",
													// 	display: "flex",
														flexSirection: "row",
													// 	alignItems: "center",
													// 	padding: "15px",
														gap: "5px",
														background: "#FBFBFB",
														border: "1px solid #E9E9E9",
														borderRadius: "8px",
													// 	flex: "none",
														order: 0,
														flexGrow: 0,
													}}
												>
													<CardBody className={`rounded-2 align-items-center text-center d-flex flex-row justify-content-left`}>
														<Icon icon='dehaze' fontSize={'large'} style={{ color: "#9D9D9D" }} />
														<Icon icon='swap_vert' className="move" fontSize="large" color="black" />
														<h5 style={{ color: "#212024", textAlign: "left", marginLeft: 10, paddingTop: 7}}>
															{parseInt(index) + 1}.
														</h5>
														<h5 style={{ color: "#212024", textAlign: "left", marginLeft: 10 }}>
															{record.text}
														</h5>
													</CardBody>
												</Card>
												{/* <Icon fontSize="medium" color="black">
													format_line_spacing
												</Icon> */}
												{/* <Icon icon='dehaze' style={{ color: "#9D9D9D" }} />
												<Icon icon='swap_vert' className="move" fontSize="medium" color="black" />
												<h6 style={{ color: "#212024", textAlign: "left" }}>
													{parseInt(index) + 1}.
												</h6>
												<h6 style={{ color: "#212024", textAlign: "left" }}>
													{record.text}
												</h6> */}
											</div>
										)} //렌더링할 행 데이터
										handles={false} //드래그 핸들 표시
										className="simple-drag"
										rowClassName="simple-drag-row"
										onUpdate={onUpdated} //정렬 목록이 변경될 때 호출됨
									/>
								</CardBody>)}
							{answerTemp.length < 1 && (
								<CardBody className='font font-16 dark mt-30'>
									질문지 불러오기 실패 하였습니다.<br /><br />
									새로고침 후 다시 시작 해주세요.
								</CardBody>
							)}
							<CardFooter className='rounded-2 d-flex flex-row align-items-center justify-content-between'>
									<Button
										variant="gradient"
										color="success"
										size="medium"
										component={Link}
										to="/question"
										sx={{ mb: 2 }}
										disabled={step === 0}
										style={{
											opacity: step === 0 ? 0 : 1,
											boxSizing: "border-box",
											display: "flex",
											flexDirection: "row",
											justifyContent: "center",
											alignItems: "center",
											padding: "10px 20px",
											background: "#FFFFFF",
											border: "1px solid #D8D8D8",
											borderRadius: "4px",
											flex: "none",
											order: 0,
											flexGrow: 0,
											color: "#5A5A5A",
											width: "67px",
										}}
										onClick={() => {
											setStep(step - 1);
										}}
									>
										이전
								</Button>
								<Button
										variant="gradient"
										color="success"
										size="medium"
										answer={answerTemp}
										sx={{ mb: 2 }}
										style={{
											boxSizing: "border-box",
											display: "flex",
											flexDirection: "row",
											justifyContent: "center",
											alignItems: "center",
											padding: "10px 20px",
											background: "#272727",
											borderRadius: "4px",
											flex: "none",
											order: 0,
											flexGrow: 0,
											color: "#FFFFFF",
											width: "65px",
										}}
										onClick={() => {
											if (step === 17) {
												navigate("/loading", { state: { answer: answerTemp } });
												// alert("마지막 문항입니다.");
											} else {
												setStep(step + 1);
											}
										}}
									>
										{step === 17 ? "제출" : "다음"}
								</Button>
							</CardFooter>
						</Card>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};
export default Question;
